// import React, { useEffect, useState } from 'react';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import { useAuthStore } from '.././store/authStore';
// import { UserRole } from '.././types/user.types';
// import { getCurrentUserFromApi } from '.././types/user.types';

// interface NavItem {
//   label: string;
//   path: string;
//   icon: React.ReactNode;
//   badge?: number;
// }

// interface NavGroup {
//   label: string;
//   icon: React.ReactNode;
//   children: NavItem[];
// }

// interface NavSection {
//   type: "section";
//   label: string;
// }

// type NavEntry = NavItem | NavGroup | NavSection;

// const icons = {
//   dashboard: (
//     <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
//   ),
//   consignment: (
//     <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M20 7H4a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"/><path d="M16 3H8l-2 4h12z"/></svg>
//   ),
//   track: (
//     <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2"/><path d="M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>
//   ),
//   drivers: (
//     <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
//   ),
//   vehicles: (
//     <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 17H3a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v9a2 2 0 01-2 2h-2M7 17a2 2 0 100 4 2 2 0 000-4zm10 0a2 2 0 100 4 2 2 0 000-4z"/></svg>
//   ),
//   charges: (
//     <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>
//   ),
//   reports: (
//     <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14,2 14,8 20,8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10,9 9,9 8,9"/></svg>
//   ),
//   users: (
//     <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
//   ),
//   settings: (
//     <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>
//   ),
//   building: (
//     <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/><path d="M9 9h.01M9 13h.01M9 17h.01M13 13h.01M13 17h.01"/></svg>
//   ),
//   delivery: (
//     <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M1 3h15v13H1zM16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
//   ),
// };

// const navByRole: Record<UserRole, NavEntry[]> = {
//   superAdmin: [
//     { type: "section", label: "Administration" },
//     { label: 'Dashboard', path: '/admin', icon: icons.dashboard },
//     // { label: 'Users', path: '/admin/allusers', icon: icons.users },
//     { label: 'Consignors', icon: icons.building, children: [
//       { label: 'Add Consignor', path: '/admin/consignors/add', icon: icons.building },
//       { label: 'Consignors (List/Edit)', path: '/admin/consignors/list', icon: icons.building },
//     ]},
//     { label: 'Company', icon: icons.building, children: [
//       { label: 'Add Company', path: '/admin/add-company', icon: icons.building },
//       { label: 'Company (List/Edit)', path: '/admin/company', icon: icons.building },
//     ]},
//     { label: 'Transporters', icon: icons.building, children: [
//       { label: 'Add Transporter', path: '/admin/transporters/add', icon: icons.building },
//       { label: 'Transporters (List/Edit)', path: '/admin/transporters/list', icon: icons.building },
//     ]},
//     { label: 'Consignments', icon: icons.building, children: [
//       { label: 'Add Consignments', path: '/admin/consignments/add', icon: icons.building },
//       { label: 'Consignments', path: '/admin/consignor/dashboard', icon: icons.consignment },
//     ]},
//     { type: "section", label: "Monitoring" },
//     { label: 'Consignments', path: '/admin/consignments', icon: icons.consignment },
//     { label: 'Reports', path: '/admin/reports', icon: icons.reports },
//     { type: "section", label: "System" },
//     { label: 'Settings', path: '/admin/settings', icon: icons.settings },
//   ],
//   admin: [
//     { type: "section", label: "Administration" },
//     { label: 'Dashboard', path: '/admin', icon: icons.dashboard },
//     // { label: 'Users', path: '/admin/allusers', icon: icons.users },
//     { label: 'Company', icon: icons.building, children: [
//       { label: 'Add Company', path: '/admin/add-company', icon: icons.building },
//       { label: 'Company (List/Edit)', path: '/admin/company', icon: icons.building },
//     ]},
//     { label: 'Consignors', icon: icons.consignment, children: [
//       { label: 'Add Consignor', path: '/admin/consignors/add', icon: icons.building },
//       { label: 'Consignors (List/Edit)', path: '/admin/consignors/list', icon: icons.building },
//     ]},
//     { label: 'Transporters', icon: icons.drivers, children: [
//       { label: 'Add Transporter', path: '/admin/transporters/add', icon: icons.building },
//       { label: 'Transporters (List/Edit)', path: '/admin/transporters/list', icon: icons.building },
//     ]},
//     { label: 'Consignments', icon: icons.building, children: [
//       { label: 'Add Consignments', path: '/admin/add/consignments', icon: icons.building },
//       { label: 'Consignments', path: '/admin/consignor/dashboard', icon: icons.consignment },
//     ]},
//     { type: "section", label: "Monitoring" },
//     // { label: 'Consignments', path: '/admin/consignments', icon: icons.consignment },
//     { label: 'Reports', path: '/admin/reports', icon: icons.reports },
//     { label: 'Settlement', path: '/admin/settlement', icon: icons.building },
//     { label: 'Settlement Record', path: '/admin/Settlementrecord', icon: icons.building },
//     { type: "section", label: "System" },
//     { label: 'Settings', path: '/admin/settings', icon: icons.settings },
//   ],
//   consignor: [
//     { type: "section", label: "Overview" },
//     { label: 'Dashboard', path: '/consignor', icon: icons.dashboard },
//     { type: "section", label: "Consignments" },
//     { label: 'Consignments', icon: icons.consignment, children: [
//       { label: 'Add Consignment', path: '/consignor/create', icon: icons.consignment },
//       { label: 'My Consignments', path: '/consignor/consignments', icon: icons.delivery },
//     ]},
//     { type: "section", label: "Tracking & Reports" },
//     { label: 'Track Shipment', path: '/consignor/track', icon: icons.track },
//     { label: 'Reports', path: '/consignor/reports', icon: icons.reports },
//   ],
//   transporter: [
//     { type: "section", label: "Overview" },
//     { label: 'Dashboard', path: '/transporter', icon: icons.dashboard },
//     { type: "section", label: "Loads" },
//     { label: 'Loads', icon: icons.consignment, children: [
//       { label: 'Manage Loads', path: '/transporter/loads', icon: icons.consignment },
//       { label: 'Charges', path: '/transporter/charges', icon: icons.charges },
//     ]},
//     { type: "section", label: "Operations" },
//     { label: 'Operations', icon: icons.vehicles, children: [
//       { label: 'Drivers', path: '/transporter/drivers', icon: icons.drivers },
//       { label: 'Fleet', path: '/transporter/fleet', icon: icons.vehicles },
//     ]},
//     { type: "section", label: "Reports" },
//     { label: 'Reports', path: '/transporter/reports', icon: icons.reports },
//   ],
//   receiver: [
//     { type: "section", label: "Overview" },
//     { label: 'Dashboard', path: '/receiver', icon: icons.dashboard },
//     { type: "section", label: "Deliveries" },
//     { label: 'Incoming', path: '/receiver/incoming', icon: icons.delivery },
//     { label: 'Track Shipment', path: '/receiver/track', icon: icons.track },
//     { label: 'History', path: '/receiver/history', icon: icons.reports },
//   ],
//   driver: [
//     { type: "section", label: "Overview" },
//     { label: 'Dashboard', path: '/driver', icon: icons.dashboard },
//     { type: "section", label: "Trips" },
//     { label: 'Current Trip', path: '/driver/trip', icon: icons.delivery },
//     { label: 'Trip History', path: '/driver/history', icon: icons.reports },
//   ],
// };

// const roleColors: Record<UserRole, string> = {
//   admin: 'from-violet-600 to-indigo-600',
//   superAdmin: 'from-yellow-600 to-indigo-600',
//   consignor: 'from-blue-600 to-cyan-500',
//   transporter: 'from-orange-500 to-amber-500',
//   receiver: 'from-emerald-500 to-teal-500',
//   driver: 'from-rose-500 to-pink-500',
// };

// export const Sidebar: React.FC = () => {
//   const { user, logout, setUser } = useAuthStore();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [collapsed, setCollapsed] = useState(false);
//   const [openGroups, setOpenGroups] = useState<Record<string, boolean>>({});
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

//   useEffect(() => {
//     let cancelled = false;

//     async function hydrateUser() {
//       if (user) return;
//       const token = localStorage.getItem("token");
//       if (!token) return;

//       const fetched = await getCurrentUserFromApi();
//       if (cancelled) return;
//       if (fetched) setUser(fetched);
//     }

//     hydrateUser();

//     return () => {
//       cancelled = true;
//     };
//   }, [setUser, user]);

//   useEffect(() => {
//     // Close mobile menu on navigation
//     setIsMobileMenuOpen(false);
//   }, [location.pathname]);

//   if (!user) return null;
//   const role = user.role as UserRole;
//   const navItems = navByRole[role] || [];
//   const gradCls = roleColors[role] || 'from-blue-600 to-indigo-600';

//   const handleLogout = () => {
//     logout();
//     navigate('/login');
//   };

//   const isGroup = (entry: NavEntry): entry is NavGroup => {
//     return typeof (entry as NavGroup).children !== 'undefined';
//   };
//   const isSection = (entry: NavEntry): entry is NavSection => {
//     return typeof (entry as NavSection).type === "string" && (entry as NavSection).type === "section";
//   };
//   const isItem = (entry: NavEntry): entry is NavItem => {
//     // It is an item if it is not section and not group (guards for TypeScript for icon/path/badge below)
//     return !isSection(entry) && !isGroup(entry);
//   };

//   // Helper to render main nav items/groups
//   const renderNavItems = (collapsedOverride = false) =>
//     navItems.map((item) => {
//       if (isSection(item)) {
//         if (collapsedOverride) return null;
//         return (
//           <div key={`${role}-section-${item.label}`} className={`${collapsedOverride ? "hidden" : "pt-2 pb-1"}`}>
//             <p className="text-[10px] font-semibold tracking-[0.22em] uppercase text-white/30 ml-2">
//               {item.label}
//             </p>
//           </div>
//         );
//       }
//       if (isGroup(item)) {
//         const isChildActive = item.children.some(
//           (child) =>
//             location.pathname === child.path ||
//             location.pathname.startsWith(child.path + "/")
//         );
//         const groupKey = `${role}-${item.label}`;
//         const isOpen = openGroups[groupKey] ?? isChildActive;
//         return (
//           <div key={groupKey} className="rounded-lg">
//             <button
//               type="button"
//               onClick={() =>
//                 setOpenGroups((prev) => ({
//                   ...prev,
//                   [groupKey]: !isOpen,
//                 }))
//               }
//               className={`group w-full flex items-center gap-3 py-3 pl-2 pr-2 rounded-lg transition-all ${
//                 isChildActive
//                   ? "bg-white/10 shadow"
//                   : "hover:bg-white/5 hover:shadow"
//               } ${collapsedOverride ? "justify-center px-0 rounded-full" : ""}`}
//             >
//               <div
//                 className={`min-w-[38px] min-h-[38px] flex items-center justify-center transition-all duration-200 rounded-md ${
//                   isChildActive
//                     ? "bg-white shadow scale-105"
//                     : "bg-black border border-[#444] scale-100"
//                 }`}
//                 style={{
//                   boxShadow: isChildActive
//                     ? "0 4px 14px 0 #111"
//                     : undefined,
//                   border: isChildActive ? "none" : undefined,
//                 }}
//               >
//                 <span
//                   className={`${
//                     isChildActive
//                       ? "text-black"
//                       : "text-white group-hover:text-white/70"
//                   } text-xl`}
//                 >
//                   {item.icon}
//                 </span>
//               </div>
//               {!collapsedOverride && (
//                 <>
//                   <span
//                     className={`whitespace-nowrap ml-1 font-medium transition-all duration-200 ${
//                       isChildActive
//                         ? "text-white font-bold"
//                         : "text-white/60 group-hover:text-white"
//                     } text-[15px]`}
//                   >
//                     {item.label}
//                   </span>
//                   <span className="ml-auto text-white/60 text-xs">
//                     {isOpen ? "▾" : "▸"}
//                   </span>
//                 </>
//               )}
//             </button>
//             {!collapsedOverride && isOpen && (
//               <div className="ml-12 mt-1 space-y-1">
//                 {item.children.map((child) => {
//                   const childActive =
//                     location.pathname === child.path ||
//                     location.pathname.startsWith(child.path + "/");
//                   return (
//                     <Link
//                       key={child.path}
//                       to={child.path}
//                       className={`block text-[13px] px-3 py-1.5 rounded-md transition-all ${
//                         childActive
//                           ? "bg-white text-black font-semibold"
//                           : "text-white/60 hover:text-white hover:bg-white/10"
//                       }`}
//                     >
//                       {child.label}
//                     </Link>
//                   );
//                 })}
//               </div>
//             )}
//           </div>
//         );
//       }
//       // Only proceed if definitely a NavItem (safe for icon, path etc)
//       if (isItem(item)) {
//         const active =
//           location.pathname === item.path ||
//           (item.path !== "/" + role &&
//             location.pathname.startsWith(item.path));
//         return (
//           <Link
//             key={item.path}
//             to={item.path}
//             title={collapsedOverride ? item.label : undefined}
//             className={`group flex items-center gap-3 py-3 pl-2 pr-2 rounded-lg transition-all ${
//               active ? "bg-white/10 shadow" : "hover:bg-white/5 hover:shadow"
//             } ${collapsedOverride ? "justify-center px-0 rounded-full" : ""}`}
//           >
//             <div
//               className={`min-w-[38px] min-h-[38px] flex items-center justify-center transition-all duration-200 rounded-md ${
//                 active
//                   ? "bg-white shadow scale-105"
//                   : "bg-black border border-[#444] scale-100"
//               }`}
//               style={{
//                 boxShadow: active ? "0 4px 14px 0 #111" : undefined,
//                 border: active ? "none" : undefined,
//               }}
//             >
//               <span
//                 className={`${
//                   active
//                     ? "text-black"
//                     : "text-white group-hover:text-white/70"
//                 } text-xl`}
//               >
//                 {item.icon}
//               </span>
//             </div>
//             <span
//               className={`whitespace-nowrap ml-1 font-medium transition-all duration-200 ${
//                 collapsedOverride
//                   ? "opacity-0 w-0 h-0 overflow-hidden"
//                   : "opacity-100"
//               } ${active ? "text-white font-bold" : "text-white/60 group-hover:text-white"} text-[15px]`}
//               style={
//                 collapsedOverride
//                   ? { width: 0, padding: 0, margin: 0 }
//                   : { letterSpacing: ".01rem" }
//               }
//             >
//               {item.label}
//             </span>
//             {!collapsedOverride && item.badge && item.badge > 0 && (
//               <span
//                 className={`ml-auto text-xs font-bold rounded-full px-1.5 py-0.5 ${
//                   active ? "bg-white text-black" : "bg-white/10 text-white"
//                 }`}
//               >
//                 {item.badge}
//               </span>
//             )}
//           </Link>
//         );
//       }
//       // Fallback; for type safety, unknown entry (shouldn't hit)
//       return null;
//     });

//   return (
//     <>
//       {/* Desktop & tablet sidebar */}
//       <aside
//         className={`sticky top-0 z-40 bottom-0 h-screen shadow-2xl bg-black transition-all duration-300 border-r border-[#252525] pt-0 flex flex-col justify-between
//           ${
//             collapsed
//               ? "w-[64px] pl-2 pr-2"
//               : "w-[220px] md:w-[200px] lg:w-[18%] pl-4 pr-2"
//           }
//           hidden sm:flex
//         `}
//         style={{
//           boxShadow: "0 6px 32px 0 #111, 4px 0 24px 0 #0d0d0d inset",
//         }}
//       >
//         <div className="flex-1 flex flex-col justify-between min-h-0">
//           <div className="flex flex-col min-h-0">
//             <div className="flex items-center justify-end mb-2 mt-4 mr-2">
//               <button
//                 className="rounded-full border-2 border-[#333] bg-black hover:bg-white/10 shadow p-1.5 transition-all duration-200"
//                 onClick={() => setCollapsed((c) => !c)}
//                 aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
//                 type="button"
//               >
//                 <svg
//                   width="20"
//                   height="20"
//                   fill="none"
//                   stroke="white"
//                   strokeWidth="2"
//                   viewBox="0 0 24 24"
//                 >
//                   {collapsed ? (
//                     <path d="M9 18l6-6-6-6" />
//                   ) : (
//                     <path d="M15 18l-6-6 6-6" />
//                   )}
//                 </svg>
//               </button>
//             </div>

//             {!collapsed && (
//               <div className="mx-1 mb-2 px-2 py-2 rounded-lg bg-white/5 border border-[#252525]">
//                 <div className="flex items-center gap-2">
//                   <div
//                     className={`w-8 h-8 rounded-full bg-gradient-to-br ${gradCls} flex items-center justify-center text-white text-xs font-bold flex-shrink-0`}
//                   >
//                     {(user.name ?? user.username ?? "?")
//                       .charAt(0)
//                       .toUpperCase()}
//                   </div>
//                   <div className="min-w-0">
//                     <p className="text-xs font-bold text-white truncate">
//                       {user.name ?? user.username}
//                     </p>
//                     <p className="text-xs text-white/50 capitalize">{role}</p>
//                   </div>
//                 </div>
//               </div>
//             )}

//             <p
//               className={`text-xs font-semibold tracking-widest text-white/60 ml-2 mb-2 uppercase transition-opacity duration-200 ${
//                 collapsed ? "opacity-0 w-0 h-0 overflow-hidden" : "opacity-95"
//               }`}
//             >
//               Menu
//             </p>

//             <nav className="flex flex-col gap-1 overflow-y-auto pr-1 bw-scroll">
//               {renderNavItems(collapsed)}
//             </nav>
//           </div>

//           <div className="pt-1 pb-6 border-t border-[#222] mt-6 min-h-[1px]">
//             <p
//               className={`text-xs font-semibold tracking-widest text-white/30 ml-2 uppercase mb-2 transition-all duration-200 ${
//                 collapsed
//                   ? "opacity-0 w-0 h-0 overflow-hidden"
//                   : "opacity-85"
//               }`}
//             >
//               General
//             </p>
//             <nav className="flex flex-col gap-1">
//               <button
//                 onClick={handleLogout}
//                 className={`group flex items-center gap-3 py-3 pl-2 pr-2 rounded-lg transition-all hover:bg-white/5 hover:shadow ${
//                   collapsed ? "justify-center px-0 rounded-full" : ""
//                 }`}
//                 type="button"
//               >
//                 <div className="min-w-[38px] min-h-[38px] flex items-center justify-center transition-all duration-200 rounded-md bg-black border border-[#444]">
//                   <span className="text-white/70 group-hover:text-white text-xl">
//                     <svg
//                       width="18"
//                       height="18"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       viewBox="0 0 24 24"
//                     >
//                       <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
//                     </svg>
//                   </span>
//                 </div>
//                 <span
//                   className={`whitespace-nowrap ml-1 font-medium transition-all duration-200 ${
//                     collapsed
//                       ? "opacity-0 w-0 h-0 overflow-hidden"
//                       : "opacity-100"
//                   } text-white/40 group-hover:text-white text-[15px]`}
//                   style={
//                     collapsed
//                       ? { width: 0, padding: 0, margin: 0 }
//                       : { letterSpacing: ".01rem" }
//                   }
//                 >
//                   Logout
//                 </span>
//               </button>
//             </nav>
//           </div>
//         </div>
//       </aside>

//       {/* Mobile horizontal nav */}
//       <nav
//         className="sm:hidden fixed bottom-0 left-0 right-0 z-50 bg-black border-t border-[#222] flex items-center justify-between px-1 py-1"
//         style={{ minHeight: 58 }}
//       >
//         {/* Mobile hamburger user button & menu toggle */}
//         <div className="flex items-center gap-1">
//           <button
//             className="p-2 rounded-full bg-gradient-to-br from-[#fff] to-[#fff] border border-[#333] mr-1"
//             onClick={() => setIsMobileMenuOpen((open) => !open)}
//             aria-label="Open menu"
//             type="button"
//           >
//             <svg
//               width="25"
//               height="25"
//               fill="none"
//               stroke="white"
//               strokeWidth="2"
//               viewBox="0 0 24 24"
//             >
//               <rect
//                 x="3"
//                 y="4"
//                 width="18"
//                 height="2"
//                 rx="1"
//                 fill="currentColor"
//                 stroke="none"
//               />
//               <rect
//                 x="3"
//                 y="11"
//                 width="18"
//                 height="2"
//                 rx="1"
//                 fill="currentColor"
//                 stroke="none"
//               />
//               <rect
//                 x="3"
//                 y="18"
//                 width="18"
//                 height="2"
//                 rx="1"
//                 fill="currentColor"
//                 stroke="none"
//               />
//             </svg>
//           </button>
//         </div>

//         {/* Main nav actions horizontally */}
//         <div className="flex-1 flex flex-row justify-around items-stretch">
//           {navItems
//             .filter((item): item is NavItem | NavGroup => !isSection(item))
//             .slice(0, 5) // Only show max 5 most important links/groups on horizontal bar (customize for your UX!)
//             .map((item, idx) => {
//               if (isGroup(item)) {
//                 // For group, render icon+label for first child, but open all in full menu overlay
//                 const child = item.children[0];
//                 const active =
//                   child &&
//                   (location.pathname === child.path ||
//                     location.pathname.startsWith(child.path + "/"));
//                 return (
//                   <Link
//                     key={child?.path || item.label || idx}
//                     to={child?.path || "#"}
//                     className={`flex flex-col items-center justify-center flex-1 px-1 py-2 rounded-md transition-all text-xs group ${
//                       active
//                         ? "bg-white/10 text-white"
//                         : "text-white/70 hover:bg-white/10 hover:text-white"
//                     }`}
//                   >
//                     <span className="mb-0.5 text-lg">{item.icon}</span>
//                     <span className="text-[10px] truncate">{item.label}</span>
//                   </Link>
//                 );
//               } else if (isItem(item)) {
//                 // Normal item (not section, not group)
//                 const active =
//                   location.pathname === item.path ||
//                   (item.path !== "/" + role &&
//                     location.pathname.startsWith(item.path));
//                 return (
//                   <Link
//                     key={item.path}
//                     to={item.path}
//                     className={`flex flex-col items-center justify-center flex-1 px-1 py-2 rounded-md transition-all text-xs group ${
//                       active
//                         ? "bg-white/10 text-white"
//                         : "text-white/70 hover:bg-white/10 hover:text-white"
//                     }`}
//                   >
//                     <span className="mb-0.5 text-lg">{item.icon}</span>
//                     <span className="text-[10px] truncate">{item.label}</span>
//                   </Link>
//                 );
//               }
//               // Never render section (filtered above), but if wrong type just skip
//               return null;
//             })}
//         </div>

//         {/* Profile/button for logout, maybe a settings icon */}
//         <button
//           className="p-2 rounded-full bg-black border border-[#222] ml-1 hidden"
//           onClick={handleLogout}
//           aria-label="Logout"
//         >
//           <svg
//             width="18"
//             height="18"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="2"
//             viewBox="0 0 24 24"
//           >
//             <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
//           </svg>
//         </button>
//       </nav>

//       {/* Mobile overlay menu when toggled */}
//       {isMobileMenuOpen && (
//         <div
//           className="sm:hidden fixed inset-0 z-50 bg-black/95 flex flex-col"
//           style={{ minHeight: "100dvh" }}
//         >
//           <div className="flex items-center justify-between px-4 py-4 border-b border-[#252525]">
//             <div className="flex items-center gap-2">
//               <div
//                 className={`w-8 h-8 rounded-full bg-gradient-to-br ${gradCls} flex items-center justify-center text-white text-xs font-bold flex-shrink-0`}
//               >
//                 {(user.name ?? user.username ?? "?")
//                   .charAt(0)
//                   .toUpperCase()}
//               </div>
//               <div className="min-w-0 flex flex-col">
//                 <span className="text-white font-bold text-sm truncate">{user.name ?? user.username}</span>
//                 <span className="text-white/60 text-xs capitalize">{role}</span>
//               </div>
//             </div>
//             <button
//               className="ml-4 p-2 flex items-center text-white bg-black border border-white/40 rounded-full"
//               onClick={() => setIsMobileMenuOpen(false)}
//               aria-label="Close Menu"
//               type="button"
//             >
//               <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                 <path d="M19 5L5 19M5 5l14 14" />
//               </svg>
//             </button>
//           </div>
//           <div className="flex-1 overflow-y-auto px-4 py-4">
//             <nav className="flex flex-col gap-1">{renderNavItems(false)}</nav>
//           </div>
//           <nav className="px-4 py-3 border-t border-white/10">
//             <button
//               onClick={handleLogout}
//               className="flex items-center gap-2 py-3 px-3 rounded-lg transition-all text-white/80 hover:bg-white/10 hover:text-white"
//               type="button"
//             >
//               <span>
//                 <svg
//                   width="20"
//                   height="20"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   viewBox="0 0 24 24"
//                 >
//                   <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
//                 </svg>
//               </span>
//               <span className="font-medium text-[15px]">Logout</span>
//             </button>
//           </nav>
//         </div>
//       )}
//     </>
//   );
// };

// export default Sidebar;
// import React, { useEffect, useState, useRef } from 'react';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import { useAuthStore } from '.././store/authStore';
// import { UserRole } from '.././types/user.types';
// import { getCurrentUserFromApi } from '.././types/user.types';

// // ── types ──────────────────────────────────────────────────────────────────────
// interface NavItem {
//   label: string;
//   path: string;
//   icon: React.ReactNode;
//   badge?: number;
// }
// interface NavGroup {
//   label: string;
//   icon: React.ReactNode;
//   children: NavItem[];
// }
// interface NavSection {
//   type: 'section';
//   label: string;
// }
// type NavEntry = NavItem | NavGroup | NavSection;

// // ── icons (unchanged) ──────────────────────────────────────────────────────────
// const icons = {
//   dashboard: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>),
//   consignment: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M20 7H4a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"/><path d="M16 3H8l-2 4h12z"/></svg>),
//   track: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2"/><path d="M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>),
//   drivers: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>),
//   vehicles: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 17H3a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v9a2 2 0 01-2 2h-2M7 17a2 2 0 100 4 2 2 0 000-4zm10 0a2 2 0 100 4 2 2 0 000-4z"/></svg>),
//   charges: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>),
//   reports: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14,2 14,8 20,8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>),
//   settings: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>),
//   building: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/><path d="M9 9h.01M9 13h.01M9 17h.01M13 13h.01M13 17h.01"/></svg>),
//   delivery: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M1 3h15v13H1zM16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>),
// };

// // ── nav config (unchanged) ─────────────────────────────────────────────────────
// const navByRole: Record<UserRole, NavEntry[]> = {
//   superAdmin: [
//     { type: 'section', label: 'Administration' },
//     { label: 'Dashboard', path: '/admin', icon: icons.dashboard },
//     { label: 'Consignors', icon: icons.building, children: [
//       { label: 'Add Consignor', path: '/admin/consignors/add', icon: icons.building },
//       { label: 'Consignors (List/Edit)', path: '/admin/consignors/list', icon: icons.building },
//     ]},
//     { label: 'Company', icon: icons.building, children: [
//       { label: 'Add Company', path: '/admin/add-company', icon: icons.building },
//       { label: 'Company (List/Edit)', path: '/admin/company', icon: icons.building },
//     ]},
//     { label: 'Transporters', icon: icons.building, children: [
//       { label: 'Add Transporter', path: '/admin/transporters/add', icon: icons.building },
//       { label: 'Transporters (List/Edit)', path: '/admin/transporters/list', icon: icons.building },
//     ]},
//     { label: 'Consignments', icon: icons.building, children: [
//       { label: 'Add Consignments', path: '/admin/consignments/add', icon: icons.building },
//       { label: 'Consignments', path: '/admin/consignor/dashboard', icon: icons.consignment },
//     ]},
//     { type: 'section', label: 'Monitoring' },
//     { label: 'Consignments', path: '/admin/consignments', icon: icons.consignment },
//     { label: 'Reports', path: '/admin/reports', icon: icons.reports },
//     { type: 'section', label: 'System' },
//     { label: 'Settings', path: '/admin/settings', icon: icons.settings },
//   ],
//   admin: [
//     { type: 'section', label: 'Administration' },
//     { label: 'Dashboard', path: '/admin', icon: icons.dashboard },
//     { label: 'Company', icon: icons.building, children: [
//       { label: 'Add Company', path: '/admin/add-company', icon: icons.building },
//       { label: 'Company (List/Edit)', path: '/admin/company', icon: icons.building },
//     ]},
//     { label: 'Consignors', icon: icons.consignment, children: [
//       { label: 'Add Consignor', path: '/admin/consignors/add', icon: icons.building },
//       { label: 'Consignors (List/Edit)', path: '/admin/consignors/list', icon: icons.building },
//     ]},
//     { label: 'Transporters', icon: icons.drivers, children: [
//       { label: 'Add Transporter', path: '/admin/transporters/add', icon: icons.building },
//       { label: 'Transporters (List/Edit)', path: '/admin/transporters/list', icon: icons.building },
//     ]},
//     { label: 'Consignments', icon: icons.building, children: [
//       { label: 'Add Consignments', path: '/admin/add/consignments', icon: icons.building },
//       { label: 'Consignments', path: '/admin/consignor/dashboard', icon: icons.consignment },
//     ]},
//     { type: 'section', label: 'Monitoring' },
//     { label: 'Reports', path: '/admin/reports', icon: icons.reports },
//     { label: 'Settlement', path: '/admin/settlement', icon: icons.building },
//     { label: 'Settlement Record', path: '/admin/Settlementrecord', icon: icons.building },
//     { type: 'section', label: 'System' },
//     { label: 'Settings', path: '/admin/settings', icon: icons.settings },
//   ],
//   consignor: [
//     { type: 'section', label: 'Overview' },
//     { label: 'Dashboard', path: '/consignor', icon: icons.dashboard },
//     { type: 'section', label: 'Consignments' },
//     { label: 'Consignments', icon: icons.consignment, children: [
//       { label: 'Add Consignment', path: '/consignor/create', icon: icons.consignment },
//       { label: 'My Consignments', path: '/consignor/consignments', icon: icons.delivery },
//     ]},
//     { type: 'section', label: 'Tracking & Reports' },
//     { label: 'Track Shipment', path: '/consignor/track', icon: icons.track },
//     { label: 'Reports', path: '/consignor/reports', icon: icons.reports },
//   ],
//   transporter: [
//     { type: 'section', label: 'Overview' },
//     { label: 'Dashboard', path: '/transporter', icon: icons.dashboard },
//     { type: 'section', label: 'Loads' },
//     { label: 'Loads', icon: icons.consignment, children: [
//       { label: 'Manage Loads', path: '/transporter/loads', icon: icons.consignment },
//       { label: 'Charges', path: '/transporter/charges', icon: icons.charges },
//     ]},
//     { type: 'section', label: 'Operations' },
//     { label: 'Operations', icon: icons.vehicles, children: [
//       { label: 'Drivers', path: '/transporter/drivers', icon: icons.drivers },
//       { label: 'Fleet', path: '/transporter/fleet', icon: icons.vehicles },
//     ]},
//     { type: 'section', label: 'Reports' },
//     { label: 'Reports', path: '/transporter/reports', icon: icons.reports },
//   ],
//   receiver: [
//     { type: 'section', label: 'Overview' },
//     { label: 'Dashboard', path: '/receiver', icon: icons.dashboard },
//     { type: 'section', label: 'Deliveries' },
//     { label: 'Incoming', path: '/receiver/incoming', icon: icons.delivery },
//     { label: 'Track Shipment', path: '/receiver/track', icon: icons.track },
//     { label: 'History', path: '/receiver/history', icon: icons.reports },
//   ],
//   driver: [
//     { type: 'section', label: 'Overview' },
//     { label: 'Dashboard', path: '/driver', icon: icons.dashboard },
//     { type: 'section', label: 'Trips' },
//     { label: 'Current Trip', path: '/driver/trip', icon: icons.delivery },
//     { label: 'Trip History', path: '/driver/history', icon: icons.reports },
//   ],
// };

// const roleColors: Record<UserRole, string> = {
//   admin: 'from-violet-600 to-indigo-600',
//   superAdmin: 'from-yellow-600 to-indigo-600',
//   consignor: 'from-blue-600 to-cyan-500',
//   transporter: 'from-orange-500 to-amber-500',
//   receiver: 'from-emerald-500 to-teal-500',
//   driver: 'from-rose-500 to-pink-500',
// };

// // ── type guards ────────────────────────────────────────────────────────────────
// const isGroup = (e: NavEntry): e is NavGroup => !!(e as NavGroup).children;
// const isSection = (e: NavEntry): e is NavSection => (e as NavSection).type === 'section';
// const isItem = (e: NavEntry): e is NavItem => !isSection(e) && !isGroup(e);

// // ── Dropdown component ─────────────────────────────────────────────────────────
// const DropdownMenu: React.FC<{
//   item: NavGroup;
//   isChildActive: boolean;
// }> = ({ item, isChildActive }) => {
//   const [open, setOpen] = useState(false);
//   const ref = useRef<HTMLDivElement>(null);
//   const location = useLocation();

//   useEffect(() => {
//     const handler = (e: MouseEvent) => {
//       if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
//     };
//     document.addEventListener('mousedown', handler);
//     return () => document.removeEventListener('mousedown', handler);
//   }, []);

//   // Close on navigation
//   useEffect(() => { setOpen(false); }, [location.pathname]);

//   return (
//     <div ref={ref} className="relative">
//       <button
//         type="button"
//         onClick={() => setOpen((o) => !o)}
//         className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-[13.5px] font-medium transition-all whitespace-nowrap
//           ${isChildActive || open
//             ? 'bg-white/10 text-white'
//             : 'text-white/55 hover:bg-white/7 hover:text-white/90'
//           }`}
//       >
//         <span className="opacity-80">{item.icon}</span>
//         {item.label}
//         <svg
//           className={`w-3 h-3 ml-0.5 opacity-50 transition-transform duration-150 ${open ? 'rotate-180' : ''}`}
//           fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"
//         >
//           <path d="M6 9l6 6 6-6" />
//         </svg>
//       </button>

//       {open && (
//         <div className="absolute top-[calc(100%+6px)] left-0 min-w-[180px] bg-[#111] border border-[#2a2a2a] rounded-xl py-1.5 z-50 shadow-xl shadow-black/50">
//           {item.children.map((child) => {
//             const active = location.pathname === child.path || location.pathname.startsWith(child.path + '/');
//             return (
//               <Link
//                 key={child.path}
//                 to={child.path}
//                 className={`flex items-center gap-2 px-3 py-2 mx-1.5 rounded-lg text-[13px] transition-all
//                   ${active ? 'bg-white/10 text-white font-semibold' : 'text-white/60 hover:bg-white/8 hover:text-white'}`}
//               >
//                 <span className="opacity-60">{child.icon}</span>
//                 {child.label}
//               </Link>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// };

// // ── Main component ─────────────────────────────────────────────────────────────
// export const Navbar: React.FC = () => {
//   const { user, logout, setUser } = useAuthStore();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

//   useEffect(() => {
//     let cancelled = false;
//     async function hydrateUser() {
//       if (user) return;
//       const token = localStorage.getItem('token');
//       if (!token) return;
//       const fetched = await getCurrentUserFromApi();
//       if (cancelled) return;
//       if (fetched) setUser(fetched);
//     }
//     hydrateUser();
//     return () => { cancelled = true; };
//   }, [setUser, user]);

//   useEffect(() => { setIsMobileMenuOpen(false); }, [location.pathname]);

//   if (!user) return null;
//   const role = user.role as UserRole;
//   const navItems = navByRole[role] || [];
//   const gradCls = roleColors[role] || 'from-blue-600 to-indigo-600';

//   const handleLogout = () => { logout(); navigate('/login'); };

//   // Render flat nav items for the top bar (sections become dividers)
//   const renderTopNav = () => {
//     const elements: React.ReactNode[] = [];
//     let sectionCount = 0;

//     navItems.forEach((item, i) => {
//       if (isSection(item)) {
//         if (sectionCount > 0) {
//           elements.push(
//             <div key={`div-${i}`} className="w-px h-5 bg-[#2a2a2a] mx-1 flex-shrink-0" />
//           );
//         }
//         elements.push(
//           <span key={`sec-${i}`} className="text-[10px] font-semibold tracking-[0.15em] uppercase text-white/22 px-2 whitespace-nowrap flex-shrink-0">
//             {item.label}
//           </span>
//         );
//         sectionCount++;
//       } else if (isGroup(item)) {
//         const isChildActive = item.children.some(
//           (c) => location.pathname === c.path || location.pathname.startsWith(c.path + '/')
//         );
//         elements.push(<DropdownMenu key={`grp-${i}`} item={item} isChildActive={isChildActive} />);
//       } else if (isItem(item)) {
//         const active = location.pathname === item.path ||
//           (item.path !== '/' + role && location.pathname.startsWith(item.path));
//         elements.push(
//           <Link
//             key={item.path}
//             to={item.path}
//             className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-[13.5px] font-medium transition-all whitespace-nowrap flex-shrink-0
//               ${active ? 'bg-white/10 text-white' : 'text-white/55 hover:bg-white/7 hover:text-white/90'}`}
//           >
//             <span className="opacity-80">{item.icon}</span>
//             {item.label}
//             {item.badge && item.badge > 0 && (
//               <span className={`ml-1 text-[11px] font-bold rounded-full px-1.5 py-0.5 ${active ? 'bg-white text-black' : 'bg-white/15 text-white'}`}>
//                 {item.badge}
//               </span>
//             )}
//           </Link>
//         );
//       }
//     });
//     return elements;
//   };

//   // Mobile: render full nav list (sections, groups, items)
//   const renderMobileNav = () =>
//     navItems.map((item, i) => {
//       if (isSection(item)) {
//         return (
//           <div key={`sec-${i}`} className="pt-3 pb-1">
//             <p className="text-[10px] font-semibold tracking-[0.22em] uppercase text-white/30 ml-2">{item.label}</p>
//           </div>
//         );
//       }
//       if (isGroup(item)) {
//         const isChildActive = item.children.some(
//           (c) => location.pathname === c.path || location.pathname.startsWith(c.path + '/')
//         );
//         return (
//           <div key={`grp-${i}`} className="space-y-0.5">
//             <div className={`flex items-center gap-3 py-2.5 px-3 rounded-lg text-[14px] font-medium text-white/40 ${isChildActive ? 'text-white/60' : ''}`}>
//               <span className="opacity-60">{item.icon}</span>
//               {item.label}
//             </div>
//             <div className="ml-8 space-y-0.5">
//               {item.children.map((child) => {
//                 const active = location.pathname === child.path || location.pathname.startsWith(child.path + '/');
//                 return (
//                   <Link
//                     key={child.path}
//                     to={child.path}
//                     className={`block px-3 py-2 rounded-lg text-[13px] transition-all
//                       ${active ? 'bg-white/10 text-white font-semibold' : 'text-white/55 hover:text-white hover:bg-white/7'}`}
//                   >
//                     {child.label}
//                   </Link>
//                 );
//               })}
//             </div>
//           </div>
//         );
//       }
//       if (isItem(item)) {
//         const active = location.pathname === item.path ||
//           (item.path !== '/' + role && location.pathname.startsWith(item.path));
//         return (
//           <Link
//             key={item.path}
//             to={item.path}
//             className={`flex items-center gap-3 py-2.5 px-3 rounded-lg text-[14px] font-medium transition-all
//               ${active ? 'bg-white/10 text-white' : 'text-white/55 hover:bg-white/7 hover:text-white'}`}
//           >
//             <span className={`${active ? 'opacity-100' : 'opacity-60'}`}>{item.icon}</span>
//             {item.label}
//             {item.badge && item.badge > 0 && (
//               <span className="ml-auto text-[11px] font-bold rounded-full px-1.5 py-0.5 bg-white/15 text-white">{item.badge}</span>
//             )}
//           </Link>
//         );
//       }
//       return null;
//     });

//   return (
//     <>
//       {/* ── Desktop / tablet top header ──────────────────────────────────────── */}
//       <header
//         className="hidden sm:flex sticky top-0 z-40 w-full bg-black border-b border-[#252525] flex-col"
//         style={{ boxShadow: '0 2px 20px 0 rgba(0,0,0,0.4)' }}
//       >
//         <div className="flex items-center gap-3 px-5 h-14">
//           {/* Logo / brand */}
//           <span className="text-[13px] font-bold tracking-[0.08em] uppercase text-white/80 mr-2 flex-shrink-0">
//             LogiTrack
//           </span>

//           {/* Scrollable nav area */}
//           <div className="flex-1 overflow-x-auto scrollbar-none min-w-0">
//             <div className="flex items-center gap-0.5 h-14">
//               {renderTopNav()}
//             </div>
//           </div>

//           {/* Right side: user + logout */}
//           <div className="flex items-center gap-2 flex-shrink-0 ml-2">
//             <div className="flex items-center gap-2 px-2.5 py-1.5 rounded-xl border border-[#2a2a2a] cursor-default">
//               <div className={`w-7 h-7 rounded-full bg-gradient-to-br ${gradCls} flex items-center justify-center text-white text-[11px] font-bold flex-shrink-0`}>
//                 {(user.name ?? user.username ?? '?').charAt(0).toUpperCase()}
//               </div>
//               <div className="flex flex-col leading-none">
//                 <span className="text-[12px] font-semibold text-white">{user.name ?? user.username}</span>
//                 <span className="text-[10px] text-white/40 capitalize">{role}</span>
//               </div>
//             </div>

//             <button
//               type="button"
//               onClick={handleLogout}
//               className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-[13px] text-white/40 hover:text-white hover:bg-white/7 transition-all"
//             >
//               <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                 <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
//               </svg>
//               Logout
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* ── Mobile bottom nav (unchanged structure, polished) ─────────────────── */}
//       <nav
//         className="sm:hidden fixed bottom-0 left-0 right-0 z-50 bg-black/95 border-t border-[#1e1e1e] backdrop-blur-md flex items-center px-2 py-1.5 gap-1"
//         style={{ minHeight: 60 }}
//       >
//         {/* Hamburger */}
//         <button
//           type="button"
//           onClick={() => setIsMobileMenuOpen((o) => !o)}
//           className="flex flex-col items-center justify-center p-2.5 rounded-xl border border-[#2a2a2a] flex-shrink-0"
//           aria-label="Open menu"
//         >
//           <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24" className="text-white/70">
//             <rect x="3" y="4" width="18" height="2" rx="1"/>
//             <rect x="3" y="11" width="18" height="2" rx="1"/>
//             <rect x="3" y="18" width="18" height="2" rx="1"/>
//           </svg>
//         </button>

//         {/* Quick links */}
//         <div className="flex-1 flex justify-around items-center">
//           {navItems
//             .filter((item): item is NavItem | NavGroup => !isSection(item))
//             .slice(0, 4)
//             .map((item, idx) => {
//               if (isGroup(item)) {
//                 const child = item.children[0];
//                 const active = child && (location.pathname === child.path || location.pathname.startsWith(child.path + '/'));
//                 return (
//                   <Link
//                     key={child?.path || idx}
//                     to={child?.path || '#'}
//                     className={`flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-xl transition-all min-w-[52px]
//                       ${active ? 'bg-white/10 text-white' : 'text-white/50'}`}
//                   >
//                     <span className="text-[18px]">{item.icon}</span>
//                     <span className="text-[9px] font-medium truncate max-w-[48px] text-center">{item.label}</span>
//                   </Link>
//                 );
//               }
//               if (isItem(item)) {
//                 const active = location.pathname === item.path ||
//                   (item.path !== '/' + role && location.pathname.startsWith(item.path));
//                 return (
//                   <Link
//                     key={item.path}
//                     to={item.path}
//                     className={`flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-xl transition-all min-w-[52px]
//                       ${active ? 'bg-white/10 text-white' : 'text-white/50'}`}
//                   >
//                     <span className="text-[18px]">{item.icon}</span>
//                     <span className="text-[9px] font-medium truncate max-w-[48px] text-center">{item.label}</span>
//                   </Link>
//                 );
//               }
//               return null;
//             })}
//         </div>

//         {/* Avatar pill */}
//         <div className={`w-9 h-9 rounded-full bg-gradient-to-br ${gradCls} flex items-center justify-center text-white text-[12px] font-bold flex-shrink-0`}>
//           {(user.name ?? user.username ?? '?').charAt(0).toUpperCase()}
//         </div>
//       </nav>

//       {/* ── Mobile full-screen overlay ────────────────────────────────────────── */}
//       {isMobileMenuOpen && (
//         <div className="sm:hidden fixed inset-0 z-50 bg-black/96 flex flex-col" style={{ minHeight: '100dvh' }}>
//           {/* Header */}
//           <div className="flex items-center justify-between px-4 py-4 border-b border-[#1e1e1e]">
//             <div className="flex items-center gap-2.5">
//               <div className={`w-9 h-9 rounded-full bg-gradient-to-br ${gradCls} flex items-center justify-center text-white text-[13px] font-bold`}>
//                 {(user.name ?? user.username ?? '?').charAt(0).toUpperCase()}
//               </div>
//               <div>
//                 <p className="text-white font-bold text-sm">{user.name ?? user.username}</p>
//                 <p className="text-white/50 text-xs capitalize">{role}</p>
//               </div>
//             </div>
//             <button
//               type="button"
//               onClick={() => setIsMobileMenuOpen(false)}
//               className="p-2 rounded-full border border-white/20 text-white"
//               aria-label="Close menu"
//             >
//               <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                 <path d="M19 5L5 19M5 5l14 14" />
//               </svg>
//             </button>
//           </div>

//           {/* Nav list */}
//           <div className="flex-1 overflow-y-auto px-4 py-3 space-y-0.5">
//             {renderMobileNav()}
//           </div>

//           {/* Logout */}
//           <div className="px-4 py-4 border-t border-white/8 pb-20">
//             <button
//               type="button"
//               onClick={handleLogout}
//               className="flex items-center gap-2.5 py-3 px-3 rounded-xl w-full text-white/60 hover:bg-white/7 hover:text-white transition-all"
//             >
//               <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                 <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
//               </svg>
//               <span className="font-medium text-[15px]">Logout</span>
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Navbar;

import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '.././store/authStore';
import { UserRole } from '.././types/user.types';
import { getCurrentUserFromApi } from '.././types/user.types';
import ReactDOM from 'react-dom';


// ── Types ──────────────────────────────────────────────────────────────────────
interface NavItem {
  label: string;
  path: string;
  icon: React.ReactNode;
  badge?: number;
}
interface NavGroup {
  label: string;
  icon: React.ReactNode;
  children: NavItem[];
}
interface NavSection {
  type: 'section';
  label: string;
}
type NavEntry = NavItem | NavGroup | NavSection;

// ── Icons ──────────────────────────────────────────────────────────────────────
const icons = {
  dashboard: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>),
  consignment: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M20 7H4a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"/><path d="M16 3H8l-2 4h12z"/></svg>),
  track: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2"/><path d="M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>),
  drivers: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>),
  vehicles: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 17H3a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v9a2 2 0 01-2 2h-2M7 17a2 2 0 100 4 2 2 0 000-4zm10 0a2 2 0 100 4 2 2 0 000-4z"/></svg>),
  charges: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>),
  reports: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14,2 14,8 20,8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>),
  settings: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>),
  building: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/><path d="M9 9h.01M9 13h.01M9 17h.01M13 13h.01M13 17h.01"/></svg>),
  delivery: (<svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M1 3h15v13H1zM16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>),
};

// ── Nav config ─────────────────────────────────────────────────────────────────
const navByRole: Record<UserRole, NavEntry[]> = {
  superAdmin: [
    { type: 'section', label: 'Administration' },
    { label: 'Dashboard', path: '/admin', icon: icons.dashboard },
    { label: 'Consignors', icon: icons.building, children: [
      { label: 'Add Consignor', path: '/admin/consignors/add', icon: icons.building },
      { label: 'Consignors (List/Edit)', path: '/admin/consignors/list', icon: icons.building },
    ]},
    { label: 'Consignee', icon: icons.consignment, children: [
      { label: 'Add Consignee', path: '/admin/consignees/add', icon: icons.building },
      { label: 'Consignee (List/Edit)', path: '/admin/consignees/list', icon: icons.building },
    ]},
    { label: 'Company', icon: icons.building, children: [
      { label: 'Add Company', path: '/admin/add-company', icon: icons.building },
      { label: 'Company (List/Edit)', path: '/admin/company', icon: icons.building },
    ]},
    { label: 'Vehicles', icon: icons.building, children: [
      { label: 'Add Vehicles', path: '/admin/transporters/add', icon: icons.building },
      { label: 'Vehicles (List/Edit)', path: '/admin/transporters/list', icon: icons.building },
    ]},
    { label: 'Consignments', icon: icons.building, children: [
      { label: 'Add Consignments', path: '/admin/consignments/add', icon: icons.building },
      { label: 'Consignments', path: '/admin/consignor/dashboard', icon: icons.consignment },
    ]},
    { type: 'section', label: 'Monitoring' },
    { label: 'Consignments', path: '/admin/consignments', icon: icons.consignment },
    { label: 'Reports', path: '/admin/reports', icon: icons.reports },
    { type: 'section', label: 'System' },
    { label: 'Settings', path: '/admin/settings', icon: icons.settings },
  ],
  admin: [
    { type: 'section', label: 'Administration' },
    { label: 'Dashboard', path: '/admin', icon: icons.dashboard },
    { label: 'Company', icon: icons.building, children: [
      { label: 'Add Company', path: '/admin/add-company', icon: icons.building },
      { label: 'Company (List/Edit)', path: '/admin/company', icon: icons.building },
    ]},
    { label: 'Consignors', icon: icons.consignment, children: [
      { label: 'Add Consignor', path: '/admin/consignors/add', icon: icons.building },
      { label: 'Consignors (List/Edit)', path: '/admin/consignors/list', icon: icons.building },
    ]},
    { label: 'Consignee', icon: icons.consignment, children: [
      { label: 'Add Consignee', path: '/admin/consignees/add', icon: icons.building },
      { label: 'Consignee (List/Edit)', path: '/admin/consignees/list', icon: icons.building },
    ]},
    { label: 'Vehicles', icon: icons.drivers, children: [
      { label: 'Add Vehicles', path: '/admin/transporters/add', icon: icons.building },
      { label: 'Vehicles (List/Edit)', path: '/admin/transporters/list', icon: icons.building },
    ]},
    { label: 'Consignments', icon: icons.building, children: [
      { label: 'Add Consignments', path: '/admin/add/consignments', icon: icons.building },
      { label: 'Consignments', path: '/admin/consignor/dashboard', icon: icons.consignment },
    ]},
    { type: 'section', label: 'Monitoring' },
    { label: 'Reports', path: '/admin/reports', icon: icons.reports },
    { label: 'Settlement', path: '/admin/settlement', icon: icons.building },
    { label: 'Settlement Record', path: '/admin/Settlementrecord', icon: icons.building },
    { type: 'section', label: 'System' },
    { label: 'Settings', path: '/admin/settings', icon: icons.settings },
  ],
  consignor: [
    { type: 'section', label: 'Overview' },
    { label: 'Dashboard', path: '/consignor', icon: icons.dashboard },
    { type: 'section', label: 'Consignments' },
    { label: 'Consignments', icon: icons.consignment, children: [
      { label: 'Add Consignment', path: '/consignor/create', icon: icons.consignment },
      { label: 'My Consignments', path: '/consignor/consignments', icon: icons.delivery },
    ]},
    { type: 'section', label: 'Tracking & Reports' },
    { label: 'Track Shipment', path: '/consignor/track', icon: icons.track },
    { label: 'Reports', path: '/consignor/reports', icon: icons.reports },
  ],
  transporter: [
    { type: 'section', label: 'Overview' },
    { label: 'Dashboard', path: '/transporter', icon: icons.dashboard },
    { type: 'section', label: 'Loads' },
    { label: 'Loads', icon: icons.consignment, children: [
      { label: 'Manage Loads', path: '/transporter/loads', icon: icons.consignment },
      { label: 'Charges', path: '/transporter/charges', icon: icons.charges },
    ]},
    { type: 'section', label: 'Operations' },
    { label: 'Operations', icon: icons.vehicles, children: [
      { label: 'Drivers', path: '/transporter/drivers', icon: icons.drivers },
      { label: 'Fleet', path: '/transporter/fleet', icon: icons.vehicles },
    ]},
    { type: 'section', label: 'Reports' },
    { label: 'Reports', path: '/transporter/reports', icon: icons.reports },
  ],
  receiver: [
    { type: 'section', label: 'Overview' },
    { label: 'Dashboard', path: '/receiver', icon: icons.dashboard },
    { type: 'section', label: 'Deliveries' },
    { label: 'Incoming', path: '/receiver/incoming', icon: icons.delivery },
    { label: 'Track Shipment', path: '/receiver/track', icon: icons.track },
    { label: 'History', path: '/receiver/history', icon: icons.reports },
  ],
  driver: [
    { type: 'section', label: 'Overview' },
    { label: 'Dashboard', path: '/driver', icon: icons.dashboard },
    { type: 'section', label: 'Trips' },
    { label: 'Current Trip', path: '/driver/trip', icon: icons.delivery },
    { label: 'Trip History', path: '/driver/history', icon: icons.reports },
  ],
};

const roleColors: Record<UserRole, string> = {
  admin: 'from-violet-600 to-indigo-600',
  superAdmin: 'from-yellow-600 to-indigo-600',
  consignor: 'from-blue-600 to-cyan-500',
  transporter: 'from-orange-500 to-amber-500',
  receiver: 'from-emerald-500 to-teal-500',
  driver: 'from-rose-500 to-pink-500',
};

// ── Type guards ────────────────────────────────────────────────────────────────
const isGroup = (e: NavEntry): e is NavGroup => !!(e as NavGroup).children;
const isSection = (e: NavEntry): e is NavSection => (e as NavSection).type === 'section';
const isItem = (e: NavEntry): e is NavItem => !isSection(e) && !isGroup(e);

// ── Dropdown (desktop) ─────────────────────────────────────────────────────────
const DropdownMenu: React.FC<{ item: NavGroup; isChildActive: boolean }> = ({ item, isChildActive }) => {
  const [open, setOpen] = useState(false);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });
  const btnRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  // Recalculate position every time it opens
  const openMenu = () => {
    if (btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      setMenuPos({
        top: rect.bottom + 6,   // 6px gap below button
        left: rect.left,
      });
    }
    setOpen(true);
  };

  const closeMenu = () => setOpen(false);

  const toggle = () => {
    if (open) closeMenu();
    else openMenu();
  };

  // Close on outside click
  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (
        menuRef.current && !menuRef.current.contains(e.target as Node) &&
        btnRef.current && !btnRef.current.contains(e.target as Node)
      ) {
        closeMenu();
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  // Close on scroll (reposition would be needed otherwise)
  useEffect(() => {
    if (!open) return;
    const handler = () => closeMenu();
    window.addEventListener('scroll', handler, true);
    return () => window.removeEventListener('scroll', handler, true);
  }, [open]);

  // Close on navigation
  useEffect(() => { closeMenu(); }, [location.pathname]);

  return (
    <div className="relative flex-shrink-0">
      <button
        ref={btnRef}
        type="button"
        onClick={toggle}
        className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-[13.5px] font-medium transition-all whitespace-nowrap
          ${isChildActive || open ? 'bg-white/10 text-white' : 'text-white/55 hover:bg-white/10 hover:text-white/90'}`}
      >
        <span className="opacity-75 flex-shrink-0">{item.icon}</span>
        {item.label}
        <svg
          className={`w-3.5 h-3.5 ml-0.5 opacity-50 transition-transform duration-150 flex-shrink-0 ${open ? 'rotate-180' : ''}`}
          fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>

      {/* Portal: renders on document.body, completely outside all overflow contexts */}
      {open && ReactDOM.createPortal(
        <div
          ref={menuRef}
          style={{
            position: 'fixed',
            top: menuPos.top,
            left: menuPos.left,
            zIndex: 99999,
            minWidth: 192,
            background: '#0d0d0d',
            border: '1px solid #2a2a2a',
            borderRadius: 12,
            padding: '6px 0',
            boxShadow: '0 8px 32px 0 rgba(0,0,0,0.7)',
          }}
        >
          {item.children.map((child) => {
            const active = location.pathname === child.path || location.pathname.startsWith(child.path + '/');
            return (
              <Link
                key={child.path}
                to={child.path}
                style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', margin: '0 6px', borderRadius: 8, fontSize: 13, textDecoration: 'none', transition: 'background 0.15s',
                  background: active ? 'rgba(255,255,255,0.12)' : 'transparent',
                  color: active ? '#ffffff' : 'rgba(255,255,255,0.6)',
                  fontWeight: active ? 600 : 400,
                }}
                onMouseEnter={e => { if (!active) (e.currentTarget as HTMLElement).style.background = 'rgba(255,255,255,0.08)'; (e.currentTarget as HTMLElement).style.color = '#fff'; }}
                onMouseLeave={e => { if (!active) (e.currentTarget as HTMLElement).style.background = 'transparent'; (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.6)'; }}
              >
                <span style={{ opacity: 0.6, flexShrink: 0 }}>{child.icon}</span>
                {child.label}
              </Link>
            );
          })}
        </div>,
        document.body
      )}
    </div>
  );
};
// ── Main Navbar ────────────────────────────────────────────────────────────────
export const Navbar: React.FC = () => {
  const { user, logout, setUser } = useAuthStore();
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function hydrateUser() {
      if (user) return;
      const token = localStorage.getItem('token');
      if (!token) return;
      const fetched = await getCurrentUserFromApi();
      if (cancelled) return;
      if (fetched) setUser(fetched);
    }
    hydrateUser();
    return () => { cancelled = true; };
  }, [setUser, user]);

  useEffect(() => { setIsMobileMenuOpen(false); }, [location.pathname]);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isMobileMenuOpen]);

  if (!user) return null;
  const role = user.role as UserRole;
  const navItems = navByRole[role] || [];
  const gradCls = roleColors[role] || 'from-blue-600 to-indigo-600';
  const handleLogout = () => { logout(); navigate('/login'); };
  const userInitial = (user.name ?? user.username ?? '?').charAt(0).toUpperCase();

  // ── Desktop top bar nav items ────────────────────────────────────────────────
  const renderTopNav = () => {
    const elements: React.ReactNode[] = [];
    let firstSection = true;

    navItems.forEach((item, i) => {
      if (isSection(item)) {
        if (!firstSection) {
          elements.push(
            <div key={`div-${i}`} className="w-px h-5 bg-[#2a2a2a] mx-2 flex-shrink-0" />
          );
        }
        firstSection = false;
        elements.push(
          <span key={`sec-${i}`} className="text-[10px] font-semibold tracking-[0.14em] uppercase text-white/25 px-1.5 whitespace-nowrap flex-shrink-0 select-none">
            {item.label}
          </span>
        );
      } else if (isGroup(item)) {
        const isChildActive = item.children.some(
          (c) => location.pathname === c.path || location.pathname.startsWith(c.path + '/')
        );
        elements.push(<DropdownMenu key={`grp-${i}`} item={item} isChildActive={isChildActive} />);
      } else if (isItem(item)) {
        const active =
          location.pathname === item.path ||
          (item.path !== '/' + role && location.pathname.startsWith(item.path));
        elements.push(
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-[13.5px] font-medium transition-all whitespace-nowrap flex-shrink-0
              ${active ? 'bg-white/10 text-white' : 'text-white/55 hover:bg-white/10 hover:text-white/90'}`}
          >
            <span className="opacity-75 flex-shrink-0">{item.icon}</span>
            {item.label}
            {item.badge && item.badge > 0 && (
              <span className={`ml-1 text-[10px] font-bold rounded-full px-1.5 py-0.5 ${active ? 'bg-white text-black' : 'bg-white/15 text-white'}`}>
                {item.badge}
              </span>
            )}
          </Link>
        );
      }
    });
    return elements;
  };

  // ── Mobile full overlay nav ──────────────────────────────────────────────────
  const renderMobileNav = () =>
    navItems.map((item, i) => {
      if (isSection(item)) {
        return (
          <div key={`sec-${i}`} className="pt-4 pb-1.5 first:pt-0">
            <p className="text-[10px] font-semibold tracking-[0.2em] uppercase text-white/30 px-3">{item.label}</p>
          </div>
        );
      }
      if (isGroup(item)) {
        const isChildActive = item.children.some(
          (c) => location.pathname === c.path || location.pathname.startsWith(c.path + '/')
        );
        return (
          <div key={`grp-${i}`}>
            <div className={`flex items-center gap-3 py-2.5 px-3 rounded-xl text-[13px] font-semibold mb-1 ${isChildActive ? 'text-white/70' : 'text-white/35'}`}>
              <span className="opacity-70">{item.icon}</span>
              {item.label}
            </div>
            <div className="ml-9 space-y-0.5 mb-1">
              {item.children.map((child) => {
                const active = location.pathname === child.path || location.pathname.startsWith(child.path + '/');
                return (
                  <Link
                    key={child.path}
                    to={child.path}
                    className={`block px-3 py-2.5 rounded-xl text-[14px] transition-all
                      ${active ? 'bg-white/12 text-white font-semibold' : 'text-white/55 hover:text-white hover:bg-white/8'}`}
                  >
                    {child.label}
                  </Link>
                );
              })}
            </div>
          </div>
        );
      }
      if (isItem(item)) {
        const active =
          location.pathname === item.path ||
          (item.path !== '/' + role && location.pathname.startsWith(item.path));
        return (
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center gap-3 py-3 px-3 rounded-xl text-[14px] font-medium transition-all
              ${active ? 'bg-white/12 text-white' : 'text-white/55 hover:bg-white/8 hover:text-white'}`}
          >
            <span className={active ? 'opacity-100' : 'opacity-60'}>{item.icon}</span>
            {item.label}
            {item.badge && item.badge > 0 && (
              <span className="ml-auto text-[11px] font-bold rounded-full px-1.5 py-0.5 bg-white/15 text-white">{item.badge}</span>
            )}
          </Link>
        );
      }
      return null;
    });

  return (
    <>
      {/* ════════════════════════════════════════════════════════════════════════
          DESKTOP / TABLET — sticky top header
          This element is NOT fixed/absolute. It is sticky inside the normal
          document flow, so content below it sits naturally underneath.
      ════════════════════════════════════════════════════════════════════════ */}
      <header
        className="hidden sm:block sticky top-0 z-40 w-full bg-[#000000] border-b border-[#222222]"
        style={{ boxShadow: '0 1px 24px 0 rgba(0,0,0,0.55)' }}
      >
        <div className="flex items-center gap-4 px-5" style={{ height: 56 }}>

          {/* Brand */}
          <span className="text-[13px] font-bold tracking-[0.1em] uppercase text-white/75 flex-shrink-0 mr-1 select-none">
            LogiTrack
          </span>

          {/* Scrollable nav — takes all remaining space */}
        {/* Scrollable nav — overflow-y must be visible so dropdowns escape */}
<div
    className="flex-1 min-w-0"
    style={{ 
        overflowX: 'auto', 
        overflowY: 'visible',   // ← critical: don't clip dropdowns
        scrollbarWidth: 'none',
        // webkit scrollbar hide
        msOverflowStyle: 'none',
    } as React.CSSProperties}
>
    <div className="flex items-center gap-0.5" style={{ height: 56, overflow: 'visible' }}>
        {renderTopNav()}
    </div>
</div>

          {/* User pill + logout — always visible, never pushed off screen */}
          <div className="flex items-center gap-2 flex-shrink-0 ml-1">
            <div className="flex items-center gap-2 px-2.5 py-1.5 rounded-xl border border-[#2a2a2a]">
              <div className={`w-7 h-7 rounded-full bg-gradient-to-br ${gradCls} flex items-center justify-center text-white text-[11px] font-bold flex-shrink-0`}>
                {userInitial}
              </div>
              <div className="flex flex-col leading-tight">
                <span className="text-[12px] font-semibold text-white leading-none">
                  {user.name ?? user.username}
                </span>
                <span className="text-[10px] text-white/40 capitalize leading-none mt-0.5">{role}</span>
              </div>
            </div>

            <button
              type="button"
              onClick={handleLogout}
              className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-[13px] text-white/40 hover:text-white/80 hover:bg-white/8 transition-all"
            >
              <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
              </svg>
              <span>Logout</span>
            </button>
          </div>

        </div>
      </header>

      {/* ════════════════════════════════════════════════════════════════════════
          MOBILE — fixed bottom tab bar
      ════════════════════════════════════════════════════════════════════════ */}
      <nav
        className="sm:hidden fixed bottom-0 left-0 right-0 z-50 flex items-center px-2 gap-1"
        style={{
          height: 62,
          background: 'rgba(0, 0, 0, 0.97)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          borderTop: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        {/* Hamburger */}
        <button
          type="button"
          onClick={() => setIsMobileMenuOpen((o) => !o)}
          aria-label="Open menu"
          className="flex flex-col items-center justify-center gap-0.5 px-3 py-2 rounded-xl flex-shrink-0"
          style={{ border: '1px solid rgba(255,255,255,0.12)' }}
        >
          <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24" className="text-white/65">
            <rect x="3" y="4" width="18" height="2" rx="1" />
            <rect x="3" y="11" width="18" height="2" rx="1" />
            <rect x="3" y="18" width="18" height="2" rx="1" />
          </svg>
          <span className="text-[9px] text-white/40 font-medium">Menu</span>
        </button>

        {/* Quick-access tabs */}
        <div className="flex-1 flex justify-around items-center">
          {navItems
            .filter((item): item is NavItem | NavGroup => !isSection(item))
            .slice(0, 4)
            .map((item, idx) => {
              if (isGroup(item)) {
                const child = item.children[0];
                const active = child &&
                  (location.pathname === child.path || location.pathname.startsWith(child.path + '/'));
                return (
                  <Link
                    key={child?.path || idx}
                    to={child?.path || '#'}
                    className={`flex flex-col items-center justify-center gap-0.5 px-2 py-1.5 rounded-xl transition-all min-w-[52px]
                      ${active ? 'text-white' : 'text-white/45'}`}
                    style={active ? { background: 'rgba(255,255,255,0.1)' } : undefined}
                  >
                    <span style={{ fontSize: 20 }}>{item.icon}</span>
                    <span className="text-[9px] font-medium truncate max-w-[52px] text-center leading-none">{item.label}</span>
                  </Link>
                );
              }
              if (isItem(item)) {
                const active =
                  location.pathname === item.path ||
                  (item.path !== '/' + role && location.pathname.startsWith(item.path));
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex flex-col items-center justify-center gap-0.5 px-2 py-1.5 rounded-xl transition-all min-w-[52px]
                      ${active ? 'text-white' : 'text-white/45'}`}
                    style={active ? { background: 'rgba(255,255,255,0.1)' } : undefined}
                  >
                    <span style={{ fontSize: 20 }}>{item.icon}</span>
                    <span className="text-[9px] font-medium truncate max-w-[52px] text-center leading-none">{item.label}</span>
                  </Link>
                );
              }
              return null;
            })}
        </div>

        {/* Avatar */}
        <div
          className={`w-9 h-9 rounded-full bg-gradient-to-br ${gradCls} flex items-center justify-center text-white text-[13px] font-bold flex-shrink-0`}
        >
          {userInitial}
        </div>
      </nav>

      {/* ════════════════════════════════════════════════════════════════════════
          MOBILE — full-screen overlay menu
          Uses solid black background, NOT bg-black/95 or transparent
      ════════════════════════════════════════════════════════════════════════ */}
      {isMobileMenuOpen && (
        <div
          className="sm:hidden fixed inset-0 z-[60] flex flex-col"
          style={{ background: '#000000' }}
        >
          {/* Top bar */}
          <div
            className="flex items-center justify-between px-4 flex-shrink-0"
            style={{ height: 60, borderBottom: '1px solid rgba(255,255,255,0.08)' }}
          >
            <div className="flex items-center gap-2.5">
              <div
                className={`w-9 h-9 rounded-full bg-gradient-to-br ${gradCls} flex items-center justify-center text-white text-[13px] font-bold flex-shrink-0`}
              >
                {userInitial}
              </div>
              <div className="flex flex-col leading-tight">
                <span className="text-white font-bold text-[14px]">{user.name ?? user.username}</span>
                <span className="text-white/45 text-[11px] capitalize">{role}</span>
              </div>
            </div>
            <button
              type="button"
              onClick={() => setIsMobileMenuOpen(false)}
              aria-label="Close menu"
              className="p-2 rounded-full text-white/70 hover:text-white"
              style={{ border: '1px solid rgba(255,255,255,0.15)' }}
            >
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M19 5L5 19M5 5l14 14" />
              </svg>
            </button>
          </div>

          {/* Scrollable nav list */}
          <div className="flex-1 overflow-y-auto px-3 py-3" style={{ paddingBottom: 80 }}>
            <nav className="space-y-0.5">
              {renderMobileNav()}
            </nav>
          </div>

          {/* Logout pinned at bottom, above the tab bar */}
          <div
            className="flex-shrink-0 px-4 py-3"
            style={{
              paddingBottom: 74, // clears the bottom nav bar
              borderTop: '1px solid rgba(255,255,255,0.06)',
              background: '#000000',
            }}
          >
            <button
              type="button"
              onClick={handleLogout}
              className="flex items-center gap-3 w-full px-3 py-3 rounded-xl text-white/50 hover:text-white/80 hover:bg-white/6 transition-all"
            >
              <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
              </svg>
              <span className="font-medium text-[15px]">Logout</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;